import { GetAvailabilityAndPriceQueryQuery } from '@notino/shared/definitions/types';
import { getVariantPriceWithoutTax } from '@notino/web-tracking';

import { dispatchTrackingEvent } from '@context/tracking/utils';
import { IAddToCartButtonProps } from '@sharedComponents/AddToCartButton/model';

import { useGetProductById } from './useGetProductById';

export const useSwogoTracking = () => {
  const getProductById = useGetProductById();

  const getTrackingProduct = (
    products: Parameters<IAddToCartButtonProps['onProductAdded']>[0],
    _product: GetAvailabilityAndPriceQueryQuery['vpProductById'],
    index: number
  ) => ({
    collection: _product.name,
    brand_name: _product.brand.name,
    product_code: _product.productCode,
    product_name: `${_product.name} ${_product.annotation}`.trim(),
    primary_category: _product.primaryCategories.category,
    primary_subcategory: _product.primaryCategories.subCategory,
    kind: _product.primaryCategories.kind,
    primary_type: _product.primaryCategories.type,
    cart_type: 'cart',
    list_position: index + 1,
    list_name: 'virtual_bundle_0',
    full_price: _product.price.value,
    price: getVariantPriceWithoutTax(_product.price),
    quantity: products.find((x) => x.id === _product.id)?.count || 0,
  });

  const trackProductsAdded: IAddToCartButtonProps['onProductAdded'] = async (
    products
  ) => {
    const productsById = await Promise.all(
      products.map(async ({ id }) => {
        return getProductById(id);
      })
    );
    dispatchTrackingEvent({
      event: 'multi_add_to_cart',
      _clear: true,
      add: {
        products: productsById.map((p, i) =>
          getTrackingProduct(products, p, i)
        ),
      },
    });
  };

  const trackProductsFailed: IAddToCartButtonProps['onProductAddFailed'] =
    async (error, products) => {
      const productsById = await Promise.all(
        products.map(async ({ id }) => {
          return getProductById(id);
        })
      );
      dispatchTrackingEvent({
        event: 'add_to_cart_failed',
        _clear: true,
        add: {
          products: productsById.map((p, i) =>
            getTrackingProduct(products, p, i)
          ),
        },
        error: {
          status: error,
        },
      });
    };

  return { trackProductsAdded, trackProductsFailed };
};
